/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiTilePattern {
    StackHz = 'StackHz',
    StackVt = 'StackVt',
    HalfHz = 'HalfHz',
    HalfVt = 'HalfVt',
    ThirdHz = 'ThirdHz',
    ThirdVt = 'ThirdVt'
}

export function ApiTilePatternFromJSON(json: any): ApiTilePattern {
    return ApiTilePatternFromJSONTyped(json, false);
}

export function ApiTilePatternFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTilePattern {
    return json as ApiTilePattern;
}

export function ApiTilePatternToJSON(value?: ApiTilePattern | null): any {
    return value as any;
}

